import React from 'react'
import { Route, Switch, BrowserRouter } from 'react-router-dom'

import AuthenticatedRoute from './shared/components/routes/AuthenticatedRoute'
import UnauthenticatedRoute from './shared/components/routes/UnauthenticatedRoute'
import Routes from './shared/infra/routes/IndexRoutes'
import NotFound from './pages/notfound/NotFound'
import Layout from "./shared/components/layout/Layout";

export default ({ childProps }) => {
  const unAuthenticatedRoutes = Routes.filter(route => !route.isAuthenticated)
  const authenticatedRoutes = Routes.filter(route => route.isAuthenticated)
  const notFullScreenRoutes = authenticatedRoutes.filter(route => !route.isFullScreen)
  const fullScreenRoutes = authenticatedRoutes.filter(route => route.isFullScreen)

  return (
    <BrowserRouter>
      <Switch>
        {unAuthenticatedRoutes.map((route, index) => (
          <UnauthenticatedRoute
            key={index}
            path={route.path}
            component={route.component}
            props={childProps}
            exact
          />
        ))}

        {fullScreenRoutes.map((route, index) => (
          <AuthenticatedRoute
            key={index}
            path={route.path}
            component={route.component}
            props={childProps}
            exact
            title={route.title}
            roles={route.roles}
          />
        ))}

        <Layout>
          {notFullScreenRoutes.map((route, index) => (
            <AuthenticatedRoute
              key={index}
              path={route.path}
              component={route.component}
              props={childProps}
              exact
              title={route.title}
              roles={route.roles}
            />
          ))}
        </Layout>

        <Route component={NotFound} />
      </Switch>
    </BrowserRouter>
  )
}
